<template>
  <Modal v-model="model"  sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="manual_out_call">
    <div class="manual_call_left">
      <div class="font_style_set"><span class="span_must">*</span>呼出计划:</div>
      <Input v-model="taskName" class="config_content" style="width: 250px"/>
    </div>
    <div class="manual_call_right">
      <div class="font_style_set">呼出目的:</div>
      <Input v-model="taskPurpose" class="config_content" style="width: 250px"/>
    </div>
    <div class="manual_call_left">
      <div class="font_style_set">开始时间:</div>
      <el-date-picker v-model="startTime" type="datetime"  align="left" :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 250px"></el-date-picker>
    </div>
    <div class="manual_call_right">
      <div class="font_style_set">结束时间:</div>
      <el-date-picker v-model="endTime" type="datetime"  align="left"  default-time="23:59:59" :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 250px"></el-date-picker>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" :disabled="isSave" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "ManualOutCallPop",
      mixins:[publicFunClass],
      props: {
        showManualOutCall:Boolean,
        callId:String
      },
      data(){
        return {
          isSave:false,
          model:false,
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          endTime:'',
          startTime:'',
          taskPurpose:'',
          taskName:'',
          title:'',
          journalType:'',
          menuId:'',
          editable:false,
        }
      },
      methods:{
        cancel:function(){
          this.$emit("closeCallEditPop",false);
        },
        save:function(){
          let that=this;
          if(!this.taskName){
            that.$Modal.info({
              title:'提示',
              content:"呼出计划不能为空"
            });
            return false;
          }
          let endTime = this.endTime;
          // if(!this.startTime){
          //   that.$Modal.info({
          //     title:'提示',
          //     content:"开始时间不能为空"
          //   });
          //   return false;
          // }
          let startTime = this.startTime;
          if(!(/^[\d\s-]+/.test(this.startTime)) && startTime){
            startTime = this.timeChange(this.startTime);
          }
          if(!startTime){
            startTime = "";
          }
          // if(!this.endTime){
          //   that.$Modal.info({
          //     title:'提示',
          //     content:"结束时间不能为空"
          //   });
          //   return false;
          // }
          if(!(/^[\d\s-]+/.test(this.endTime)) && endTime){
            endTime = this.timeChange(this.endTime);
          }
          if(!endTime){
            endTime = "";
          }
          // let reg = new RegExp('-', 'g')
          // if((new Date(endTime.replace(reg, '/'))) < (new Date(startTime.replace(reg, '/')))){
          //   that.$Modal.info({
          //     title:'提示',
          //     content:"结束时间不能小于开始时间"
          //   });
          //   return false;
          // }
          let url = "";
          if(this.callId!=""){
            url="calltask/updateCallTask.json"
          }else{
            url="calltask/insertCallTask.json"
          }
          let param= {
            taskPurpose:this.taskPurpose,
            journalType:this.journalType,
            menuId:this.menuId,
            taskName:this.taskName,
            taskType:'1',
            startTime:startTime,
            endTime:endTime,
            id:this.callId,
          }
          this.isSave= true;
          this.$http.post(url,param) .then(function (res) {
            let result=res.data.flag;
            setTimeout(() => {
              that.isSave = false;
            }, 1000);
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("操作成功");
            that.$emit("closeCallEditPop",true);
          });
        },
        initSearch:function () {
          let that=this;
          let param={
            journalType:"null",
            menuId:"null",
            pageNum:"1",
            pageSize:"1",
            taskType:"1",
            id:this.callId
          };
          this.$http.post("calltask/selectCallTask.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let list=res.data.obj.list.content[0];
            that.taskName=list.taskName;
            that.taskPurpose=list.taskPurpose;
            that.startTime=list.startTime;
            that.endTime=list.endTime;
          });
        },
      },
      watch:{
        showManualOutCall:function () {
          this.model=this.showManualOutCall;
          if(this.showManualOutCall){
            this.isSave= false;
            if(!this.callId){
              this.title='添加手动呼出任务';
              this.taskName='';
              this.taskPurpose='';
              this.startTime='';
              this.endTime='';
              this.journalType="呼出管理=>呼出任务=>新建手动呼出";
              this.menuId="2_2-4";
            }else{
              this.title='编辑手动呼出任务';
              this.journalType="呼出管理=>呼出任务=>编辑手动呼出";
              this.menuId="2_2-1";
              this.initSearch();
            }
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/callManage/ManualOutCallPop.vue